import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import InputForm from "../../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {Card} from "../../../../../components/card/card.jsx";

const LaneAliasCameras = ({target, gridRef, cameras, title, moveTo, secondGridRef}) => {
    const [columnDefs,] = useState([
        { field: "formatted_description", headerName: "Nome", sort: "asc", flex: 1, },
    ]);

    const handleFilter = useCallback(({target: {value}}) => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            value,
        )
    }, []);

    const rowSelection = useMemo(() => ({
        mode: 'multiRow',
        checkboxes: false,
        enableClickSelection: true,
        headerCheckbox: false,
    }), []);

    const dragState = useRef({startIndex: null, dragged: false});

    const onCellDoubleClicked = useCallback(({node}) => {
        moveTo(node.data);
    }, [])

    const onCellMouseDown = useCallback(({node, event}) => {
        if (event?.button !== 0 || node.rowIndex === null) return;
        dragState.current = {startIndex: node.rowIndex, dragged: false};
    }, []);

    const onCellMouseOver = useCallback(({node}) => {
        const {startIndex} = dragState.current;
        if (startIndex === null || node.rowIndex === null) return;
        if (node.rowIndex === startIndex && !dragState.current.dragged) return;

        dragState.current.dragged = true;
        const start = Math.min(startIndex, node.rowIndex);
        const end = Math.max(startIndex, node.rowIndex);

        gridRef.current?.api?.forEachNode((n) => {
            const shouldSelect = n.rowIndex >= start && n.rowIndex <= end;
            if (n.isSelected() !== shouldSelect) n.setSelected(shouldSelect);
        });
        secondGridRef.current?.api?.deselectAll?.();
    }, []);

    const onCellClicked = useCallback(({node}) => {
        secondGridRef.current?.api?.deselectAll?.();
        if (dragState.current.dragged) {
            node.setSelected(true);
        }
    }, [])

    useEffect(() => {
        const reset = () => { dragState.current = {startIndex: null, dragged: false}; };
        window.addEventListener('mouseup', reset);
        return () => window.removeEventListener('mouseup', reset);
    }, []);

    const defaultColDef = useMemo(() => ({
        tooltipValueGetter: (params) => {
            if (params.value === null || params.value === undefined) return "";
            return String(params.value);
        },
    }), []);

    return (
        <section className={"grow"}>
            <Card>
                <Card.Header>
                    <Card.Title>{title}</Card.Title>
                </Card.Header>
                <Card.Body className={"space-y-2"}>
                    <InputForm
                        id={target}
                        label={"Pesquisar"}
                        onChange={handleFilter}
                    />

                    <div className={"ag-theme-quartz aggrid-row-pointer grid h-[calc(100vh-287px)]"}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={cameras}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            defaultColDef={defaultColDef}
                            rowSelection={rowSelection}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            onCellDoubleClicked={onCellDoubleClicked}
                            onCellClicked={onCellClicked}
                            onCellMouseDown={onCellMouseDown}
                            onCellMouseOver={onCellMouseOver}
                            theme={aggridUtils.generalTheme()}
                            tooltipShowDelay={200}
                            onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                        />
                    </div>
                </Card.Body>
            </Card>
        </section>
    );
};

export default LaneAliasCameras;